import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/routeHead";
import LoyaltyProgram from "@/pages/LoyaltyProgram";

export const Route = createFileRoute("/loyalty-program")({
  head: () => pageHead({
    title: 'Loyalty Program',
    description: 'Join the Rex & Sons RVs loyalty program — earn rewards on parts, service and accessories at our Castle Hayne, NC dealership.',
    path: '/loyalty-program',
  }),
  component: LoyaltyProgram,
});
